import translation from './zod.json';
export default {
  ...translation,
  custom: {
    allPlansNeedTenants: 'All plans must be assigned to at least one tenant.',
    allTenantsNeedPlans: 'All tenants must have at least one plan assigned.',
    byod_registration_date_before_deregistration: 'BYOD registration date must be before or equal to deregistration date',
    byod_registration_date_required: 'BYOD registration date is required when deregistration date is specified',
    city: 'Please enter a valid city.',
    city_required: 'City is required',
    country_code_required: 'Country code is required',
    date_must_not_be_future: 'Future dates cannot be set. Please enter today or an earlier date.',
    department_required: 'Department is required',
    department_required_with_position: 'Department is required when position is selected',
    device: {
      placement_date_required: 'Please enter a placement date',
      placement_required: 'Please select a placement location',
      responsible_person_required: 'Please select a responsible person',
      responsible_person_start_date_required: 'Please enter a start date',
      warehousing_date_and_place_both_required: 'Please enter both the warehousing start date and the storage location',
      warehousing_date_required: 'Please enter a warehousing start date',
      warehousing_required: 'Please select a warehousing placement location'
    },
    duns_format_error: 'DUNS must be exactly 9 digits',
    email_all_length_max: 'The number of characters in all exceeds limit(max:{{value}})',
    email_regexp_double_byte: 'The target contains double-byte characters.',
    email_regexp_error: 'The target is incorrect format.',
    file: {
      file_extension_not_allowed: 'Not allowed file extension',
      file_max_exceeded: 'The number of files exceeds the limit',
      file_size_exceeded: 'The file size exceeds the limit',
      file_type_not_allowed: 'Not allowed file type'
    },
    invalid_mac_address: 'Invalid MAC address',
    invalid_only_date: 'Invalid date',
    invalid_postal_code: 'Please enter a valid postal code.',
    invalidBusinessHourRange: 'End time must be after the start time.',
    invalidDateRange: 'End date must be after the start date.',
    lei_format_error: 'LEI must be exactly 20 alphanumeric characters',
    license: {
      invalid_date_range: 'Start date must be earlier than expiration date',
      invalid_purchase_renewal_date: 'Purchase date must be earlier than renewal date',
      required_valid_from: 'License start date is required'
    },
    max_integer_error: '{{label}} must be {{max}} or less',
    max_length_error: '{{label}} must be {{maxLength}} characters or less',
    max_order_qty_gte_min: 'Maximum order quantity must be greater than or equal to the minimum order quantity',
    min_integer_error: '{{label}} must be {{min}} or more',
    min_length_error: '{{label}} must be {{minLength}} characters or more',
    network: {
      name_whitespace_only: 'Must contain characters other than whitespace'
    },
    no_empty_text: 'Empty text is not allowed',
    number_invalid: 'Enter a valid number',
    number_non_negative: 'Enter a number of 0 or greater',
    number_non_negative_integer: 'Enter a whole number of 0 or greater',
    number_positive: 'Enter a number greater than 0',
    pattern_error: '{{label}} must be {{pattern}}',
    percent_0_100: 'Enter a value between 0 and 100',
    phone_number_invalid: 'The phone number is invalid.',
    place_name_required: 'Place name is required when registering a new place',
    port_required: 'Port count is required',
    postal_code_invalid: 'Please enter a valid postal code.',
    postal_code_required: 'Postal code is required',
    postalCode: 'Please enter a valid postal code.',
    procured_date_required_with_current_date: 'Procurement date is required.',
    procurement_type_required: 'Procurement type is required',
    required: 'This field is required.',
    required_error: '{{label}} is required',
    select_error: '{{label}} must be one of the following: {{options}}',
    start_date_required: 'Start date is required',
    state_province_code_required: 'State or province code is required',
    stateProvinceCode: 'Please select a state or province.',
    storage_required: 'Storage size is required',
    street_address_required: 'Street address is required',
    streetAddress: 'Street address is required.',
    system_error: 'An unexpected error occurred',
    target_person_required: 'Please select a person',
    url_regexp_error: 'Please enter a valid URL format for {{label}}',
    validation_error: 'Invalid value for {{label}}',
    validation_system_error: 'An error occurred while validating {{label}}',
    whitespace_only: 'Please enter characters other than whitespace'
  }
};